import * as React from 'react';
import { Component, deps, inject, observer } from '../lib/component';
import { FormattedMessage } from 'react-intl';
import { AccountLayout } from '../components/account/layout';
import { AccountOrder } from '../components/account/order';
import { ChannelSchema } from '../types/schema';

export interface AccountOrderPageProps {
  order?: any;
  channels?: Array<ChannelSchema>;
  loading?: boolean;
}

@inject(deps)
@observer
export class AccountOrderPage extends Component<AccountOrderPageProps> {
  render() {
    const { isMobile } = this.props.model.ui;
    const { order, channels = [], loading } = this.props.model.page.accountOrder;
    const defaultOrderSequence = 0;
    const orderSequence = order ? order.sequence : defaultOrderSequence;

    const sequence = loading ? 'Loading...' : orderSequence;

    return (
      <AccountLayout>
        <FormattedMessage tagName="h2" id="account.order.title" values={{ sequence }} />
        <AccountOrder loading={loading} order={order} channels={channels} isMobile={isMobile} />
      </AccountLayout>
    );
  }
}
